<template>
    <div class="lightswitch">
        <span v-if="label" class="lightswitch__label">{{ label }}</span>
        <label class="lightswitch__switch">
            <input
                type="checkbox"
                :name="name"
                ref="checkbox"
                :checked="value"
                @change="$emit('input', $event.target.checked)" />

            <span class="lightswitch__slider">
                <span v-if="showLabels" class="lightswitch__slider-label">{{ getOffLabel }}</span>
                <span v-if="showLabels" class="lightswitch__slider-label">{{ getOnLabel }}</span>
            </span>
        </label>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'LightswitchElement',
    components: {

    },
    props: {
        label: String,
        name: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        },
        showLabels: {
            type: Boolean,
            default: true
        },
        labelOn: String,
        labelOff: String,
        id: String
    },

    data: () => {
        return {
        }
    },
    computed: {
        ...mapGetters('uitexts', {
            t: 't',
        }),

        getOnLabel() {
            return this.labelOn ? this.labelOn : this.t('ja');
        },

        getOffLabel() {
            return this.labelOff ? this.labelOff : this.t('nein');
        },
    },
    created() {
    },
    mounted() {

    },
    methods: {

    },
}
</script>
